import React from 'react'
import Creatable, { makeCreatableSelect } from 'react-select/creatable'
import makeAnimated from 'react-select/animated'
import { LocaleContext } from 'contexts/locale'
import { isBrowser, isMobile } from 'react-device-detect'
import renderHTML from 'react-render-html'

import './styles.scss'

let options = []

type Props = {
  council: string
  filterHandler: Function
  onHandleDropdown: Function
  focusHandler: Function
  blurHandler: Function
  globalLocale: string[]
  userSetFilter: boolean
  isFixed: boolean
}

const animatedComponents = makeAnimated()

export default class DropdownComponent extends React.Component<Props> {
  state = {
    selectedOption: null,
    fixedSearch: false,
    defaultValue: [],
    userChangedFilter: false
  }

  componentWillMount() {
    const locale = this.context
    const messages = require('./locales/' + locale + '.yml')
    const globalMessages = require('locales/' + locale + '.yml')
    this.setState({
      locale: messages,
      globalLocale: globalMessages
    })
  }

  componentDidMount() {
    if (this.props.council === 'nr') {
      if (this.context === 'de') {
        this.setState({
          defaultValue: [
            {
              value: ['w', 'Frau', 'Femme', 'feminin', 'féminin', 'weiblich'],
              label: this.state.locale.Gender.w,
              type: 'gender'
            },
            {
              value: ['zh', 'Zürich', 'Zurich'],
              label: this.props.globalLocale.UI.Global.Cantons.ZH,
              type: 'canton'
            }
          ]
        })
      } else {
        this.setState({
          defaultValue: [
            {
              value: ['w', 'Frau', 'Femme', 'feminin', 'féminin', 'weiblich'],
              label: this.state.locale.Gender.w,
              type: 'gender'
            },
            {
              value: ['vd', 'Waadt', 'Vaud'],
              label: this.props.globalLocale.UI.Global.Cantons.VD,
              type: 'canton'
            },
            {
              value: ['ge', 'Genf', 'Genève'],
              label: this.props.globalLocale.UI.Global.Cantons.GE,
              type: 'canton'
            }
          ]
        })
      }
    } else {
      this.setState({
        defaultValue: [
          {
            value: ['m', 'Mann', 'Homme', 'masculin', 'männlich'],
            label: this.state.locale.Gender.m,
            type: 'gender'
          }
        ]
      })
    }
    document
      .querySelector('#' + this.props.council + '-dropdown input')
      .addEventListener('focus', e => this.props.focusHandler())
    document
      .querySelector('#' + this.props.council + '-dropdown input')
      .addEventListener('blur', e => this.props.blurHandler())
    if (options.length === 0) {
      options.push(
        {
          value: ['w', 'Frau', 'Femme', 'feminin', 'féminin', 'weiblich'],
          label: this.state.locale.Gender.w,
          type: 'gender'
        },
        {
          value: ['m', 'Mann', 'Homme', 'masculin', 'männlich'],
          label: this.state.locale.Gender.m,
          type: 'gender'
        },
        {
          value: ['ag', 'Aargau', 'Argovie'],
          label: this.props.globalLocale.UI.Global.Cantons.AG,
          type: 'canton'
        },
        {
          value: [
            'ai',
            'Appenzell Innerrhoden',
            'Appenzell Rhodes-Intérieures'
          ],
          label: this.props.globalLocale.UI.Global.Cantons.AI,
          type: 'canton'
        },
        {
          value: [
            'ar',
            'Appenzell Ausserrhoden',
            'Appenzell Rhodes-Extérieures'
          ],
          label: this.props.globalLocale.UI.Global.Cantons.AR,
          type: 'canton'
        },
        {
          value: ['be', 'Bern', 'Berne'],
          label: this.props.globalLocale.UI.Global.Cantons.BE,
          type: 'canton'
        },
        {
          value: ['bl', 'Basel Landschaft', 'Bâle-Campagne'],
          label: this.props.globalLocale.UI.Global.Cantons.BL,
          type: 'canton'
        },
        {
          value: ['bs', 'Basel Stadt', 'Bâle-Ville'],
          label: this.props.globalLocale.UI.Global.Cantons.BS,
          type: 'canton'
        },
        {
          value: ['fr', 'Freiburg', 'Fribourg'],
          label: this.props.globalLocale.UI.Global.Cantons.FR,
          type: 'canton'
        },
        {
          value: ['ge', 'Genf', 'Genève'],
          label: this.props.globalLocale.UI.Global.Cantons.GE,
          type: 'canton'
        },
        {
          value: ['gl', 'Glarus', 'Glarus'],
          label: this.props.globalLocale.UI.Global.Cantons.GL,
          type: 'canton'
        },
        {
          value: ['gr', 'Graubünden', 'Grisons'],
          label: this.props.globalLocale.UI.Global.Cantons.GR,
          type: 'canton'
        },
        {
          value: ['ju', 'Jura', 'Jura'],
          label: this.props.globalLocale.UI.Global.Cantons.JU,
          type: 'canton'
        },
        {
          value: ['lu', 'Luzern', 'Lucerne'],
          label: this.props.globalLocale.UI.Global.Cantons.LU,
          type: 'canton'
        },
        {
          value: ['ne', 'Neuenburg', 'Neuchâtel'],
          label: this.props.globalLocale.UI.Global.Cantons.NE,
          type: 'canton'
        },
        {
          value: ['nw', 'Nidwalden', 'Nidwald'],
          label: this.props.globalLocale.UI.Global.Cantons.NW,
          type: 'canton'
        },
        {
          value: ['ow', 'Obwalden', 'Obwald'],
          label: this.props.globalLocale.UI.Global.Cantons.OW,
          type: 'canton'
        },
        {
          value: ['sg', 'St. Gallen', 'St. Gall'],
          label: this.props.globalLocale.UI.Global.Cantons.SG,
          type: 'canton'
        },
        {
          value: ['sh', 'Schaffhausen', 'Schaffhouse'],
          label: this.props.globalLocale.UI.Global.Cantons.SH,
          type: 'canton'
        },
        {
          value: ['so', 'Solothurn', 'Soleure'],
          label: this.props.globalLocale.UI.Global.Cantons.SO,
          type: 'canton'
        },
        {
          value: ['sz', 'Schwyz', 'Schwyz'],
          label: this.props.globalLocale.UI.Global.Cantons.SZ,
          type: 'canton'
        },
        {
          value: ['tg', 'Thurgau', 'Thurgovie'],
          label: this.props.globalLocale.UI.Global.Cantons.TG,
          type: 'canton'
        },
        {
          value: ['ti', 'Tessin', 'Tessin'],
          label: this.props.globalLocale.UI.Global.Cantons.TI,
          type: 'canton'
        },
        {
          value: ['ur', 'Uri', 'Uri'],
          label: this.props.globalLocale.UI.Global.Cantons.UR,
          type: 'canton'
        },
        {
          value: ['vd', 'Waadt', 'Vaud'],
          label: this.props.globalLocale.UI.Global.Cantons.VD,
          type: 'canton'
        },
        {
          value: ['vs', 'Wallis', 'Valais'],
          label: this.props.globalLocale.UI.Global.Cantons.VS,
          type: 'canton'
        },
        {
          value: ['zg', 'Zug', 'Zoug'],
          label: this.props.globalLocale.UI.Global.Cantons.ZG,
          type: 'canton'
        },
        {
          value: ['zh', 'Zürich', 'Zurich'],
          label: this.props.globalLocale.UI.Global.Cantons.ZH,
          type: 'canton'
        },

        {
          value: [
            'bdp',
            'pbd',
            'Bürgerlich-Demokratische Partei',
            'Parti bourgeois démocratique suisse',
            'Conservative Democratic Party'
          ],
          label: this.props.globalLocale.UI.Global.Parties.BDP,
          type: 'party'
        },
        {
          value: [
            'cvp',
            'pdc',
            'Christlichdemokratische Volkspartei der Schweiz',
            'Parti Démocrate-Chrétien',
            'Christian-democratic'
          ],
          label: this.props.globalLocale.UI.Global.Parties.CVP,
          type: 'party'
        },
        {
          value: [
            'evp',
            'pev',
            'Evangelische Volkspartei',
            'Parti évangelique suisse',
            "Evangelical People's Party"
          ],
          label: this.props.globalLocale.UI.Global.Parties.EVP,
          type: 'party'
        },
        {
          value: [
            'fdp',
            'plr',
            'Freisinnig-Demokratische Partei',
            'Parti radical-démocratique',
            'Free Democratic Party'
          ],
          label: this.props.globalLocale.UI.Global.Parties.FDP,
          type: 'party'
        },
        {
          value: [
            'glp',
            'Vert’libéraux',
            'Grünliberale Partei',
            "Parti vert'libéral",
            'Green Liberal Party'
          ],
          label: this.props.globalLocale.UI.Global.Parties.GLP,
          type: 'party'
        },
        {
          value: ['grüne', 'Verts', 'Grüne Partei', 'Les verts', 'Green Party'],
          label: this.props.globalLocale.UI.Global.Parties['Grüne'],
          type: 'party'
        },
        {
          value: [
            'ldp',
            'ldp',
            'Liberale Partei der Schweiz',
            'Parti liberal suisse',
            'The Liberal Party'
          ],
          label: this.props.globalLocale.UI.Global.Parties.LDP,
          type: 'party'
        },
        {
          value: [
            'lega',
            'lega',
            'Liga der Tessiner',
            'Ligue des Tessinois',
            'Ticino League'
          ],
          label: this.props.globalLocale.UI.Global.Parties.Lega,
          type: 'party'
        },
        {
          value: [
            'mcg',
            'mcg',
            'Genfer Bürgerbewegung',
            'Mouvement Citoyens Genevois',
            "Geneva Citizens' Movement"
          ],
          label: this.props.globalLocale.UI.Global.Parties.MCG,
          type: 'party'
        },
        {
          value: [
            'parteilos',
            'indépendant',
            'Parteilos',
            'ohne Partei',
            'sans parti'
          ],
          label: this.props.globalLocale.UI.Global.Parties.Parteilos,
          type: 'party'
        },
        {
          value: [
            'pda',
            'pdt',
            'Partei der Arbeit der Schweiz',
            'Parti Suisse du Travail',
            'Swiss Party of Labour'
          ],
          label: this.props.globalLocale.UI.Global.Parties.PdA,
          type: 'party'
        },
        {
          value: [
            'sp',
            'ps',
            'Sozialdemokratische Partei der Schweiz',
            'Parti socialiste suisse',
            'Social Democratic Party'
          ],
          label: this.props.globalLocale.UI.Global.Parties.SP,
          type: 'party'
        },
        {
          value: [
            'svp',
            'udc',
            'Schweizerische Volkspartei',
            'Union démocratique du centre',
            "Swiss People's Party"
          ],
          label: this.props.globalLocale.UI.Global.Parties.SVP,
          type: 'party'
        },
        {
          value: ['andere links', 'autre (gauche)', 'andere', 'autres'],
          label: this.props.globalLocale.UI.Global.Parties['Andere links'],
          type: 'party'
        },
        {
          value: ['andere rechts', 'autre (droite)', 'andere', 'autres'],
          label: this.props.globalLocale.UI.Global.Parties['Andere rechts'],
          type: 'party'
        }
      )
    }
  }

  componentWillUnmount() {
    options = []
  }

  handleChange = selectedOption => {
    /* Make sure default values disappear when user changes filters */
    if (!this.state.userChangedFilter) {
      this.setState({
        userChangedFilter: true
      })
    }
    this.setState({ selectedOption }, () => {
      if (selectedOption) {
        if (selectedOption.filter(option => option.__isNew__).length > 0) {
          const ownFilters = selectedOption.filter(option => option.__isNew__)
          this.props.onHandleDropdown(this.state.selectedOption, ownFilters)
        } else {
          this.props.onHandleDropdown(this.state.selectedOption)
        }
      } else {
        this.props.onHandleDropdown(this.state.selectedOption)
      }
    })
  }

  render() {
    const { selectedOption, locale } = this.state

    return (
      <Creatable
        id={this.props.council + '-dropdown'}
        formatCreateLabel={string =>
          renderHTML(
            locale.Dropdown.CreateNew[0] +
              '<strong>' +
              string +
              '</strong>' +
              locale.Dropdown.CreateNew[1]
          )
        }
        styles={{
          option: provided => ({
            ...provided
          }),
          control: styles => ({
            ...styles,
            boxShadow: 'none'
          }),
          menu: styles => ({
            ...styles,
            maxHeight: isMobile ? '30vh' : '50vh'
          }),
          menuList: styles => ({
            ...styles,
            maxHeight: isMobile ? '30vh' : '50vh'
          }),
          multiValue: styles => ({
            ...styles,
            ':hover': {
              backgroundColor: '#ddd'
            }
          }),
          multiValueRemove: styles => ({
            ...styles,
            ':hover': {
              backgroundColor: '#E23C4E',
              cursor: 'pointer',
              color: 'white'
            }
          })
        }}
        autoFocus={this.props.isFixed}
        classNamePrefix='dropdown'
        isSearchable
        isClearable={this.props.isFixed || isBrowser}
        isMulti
        placeholder={this.props.placeholder}
        components={animatedComponents}
        value={
          selectedOption || this.props.userSetFilter
            ? selectedOption
            : this.state.defaultValue
        }
        onChange={this.handleChange}
        noOptionsMessage={() => locale.Dropdown.NoData}
        options={options}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#E7F1F6',
            primary: '#007abf'
          }
        })}
      />
    )
  }
}

DropdownComponent.contextType = LocaleContext
